export interface FontOption {
  name: string;
  url: string;
}

/**
 * Сливает список загруженных шрифтов с текущим выбранным шрифтом шаблона.
 * Гарантирует, что текущий шрифт всегда виден в селекторе — даже если запрос
 * списка шрифтов (/fonts) не сработал. Аналогично тому, как поле лого всегда
 * показывает текущий логотип.
 */
export function buildFontOptions(
  fetched: FontOption[] | undefined,
  current?: { url?: string; name?: string }
): FontOption[] {
  const list = [...(fetched ?? [])];

  if (current?.url && current.name) {
    const exists = list.some((f) => f.url === current.url);
    if (!exists) {
      list.unshift({ name: current.name, url: current.url });
    }
  }

  return list;
}
